import React from 'react'


const Footer = (props) => {
    return(
        <footer class="page-footer">
            <div class="container">
            <div class="row">
                <div class="col l6 s12">
                <h5 class="white-text">MessageBoard</h5>
                <p class="grey-text text-lighten-4">Post</p>
                </div>
                <div class="col l4 offset-l2 s12">
                <h5 class="white-text">Links</h5>
                <ul>
                    <li><a class="grey-text text-lighten-3" href="#!">Link 1</a></li>

                </ul>
                </div>
            </div>
            </div>
            <div class="footer-copyright">
            <div class="container">
            © 2019 Copyright Text
            <a class="grey-text text-lighten-4 right" href="#!">More Links</a>
            </div>
            </div>
        </footer>
    )
}

export default Footer